import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { formatPrice } from 'src/helpers/formatPrice'
import { useGetFavoritesFeedQuery } from 'src/redux/api'

// Favourites news feed (roadmap 41 C3): recent changes to the listings the user
// hearted — a price drop is highlighted. Self-hides when there is nothing new.
const FavoritesFeed: FC = () => {
  const { t } = useTranslation()
  const { data } = useGetFavoritesFeedQuery()
  const items = data?.items ?? []
  if (!items.length) return null

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-xl font-black text-ink">{t('feed.title')}</h2>
      <ul className="flex flex-col gap-2">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/announcement/${item.propertyId}`}
              className="flex items-center gap-3 bg-surface rounded-2xl p-3 shadow-[0rem_.25rem_1.5rem_rgba(0,0,0,0.09)] hover:bg-page transition-colors"
            >
              <div className="w-14 h-14 rounded-lg overflow-hidden bg-brand-soft flex-shrink-0">
                {item.image && (
                  <img src={item.image} alt="" className="object-cover size-full" loading="lazy" />
                )}
              </div>
              <div className="flex flex-col min-w-0 gap-1">
                <span className="truncate text-ink font-semibold break-words">
                  {item.addressString}
                </span>
                {item.kind === 'PRICE' &&
                  item.oldValue != null &&
                  item.newValue != null &&
                  item.currency && (
                    <span className="text-sm flex items-center gap-1.5 flex-wrap">
                      <span className={item.dropped ? 'text-success font-bold' : 'text-ink-2'}>
                        {item.dropped ? t('feed.price_dropped') : t('feed.price_changed')}
                      </span>
                      <span className="line-through text-ink-3">
                        {formatPrice(item.oldValue, item.currency)}
                      </span>
                      <span className="font-black text-ink">
                        → {formatPrice(item.newValue, item.currency)}
                      </span>
                    </span>
                  )}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default FavoritesFeed
